import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import Cabinet from '../cabinet/CabinetContainer'

const CabinetRoute = ({ email }) => {
  return email
    ? <Cabinet />
    : (<Redirect to='/' />) // redirect to main page, if not logged in
}

const mapStateToProps = (state) => ({
  email: state.authorization.email
})

export default connect(mapStateToProps)(CabinetRoute)
